import { createUseStyles } from 'react-jss'
import { DARK_GRAY_20 } from '@omnilert/components'

export default createUseStyles({
  actionSheet: {
    borderTopRightRadius: '30px',
    borderTopLeftRadius: '30px'
  },
  otherSubmitButtonTitle: {
    fontSize: '18px'
  },
  input: {
    borderRadius: '4.56px !important',
    paddingRight: '0 !important',
    marginRight: '10px',
    fontSize: ['24px', '!important'],
    fontWeight: ['bold', '!important'],
    '&::placeholder': {
      fontSize: ['22px', '!important']
    }
  },
  formInputs: {
    display: 'flex',
    justifyContent: 'center'
  },
  actionItem: {
    alignItems: 'center',
    borderTop: ['1px', 'solid', DARK_GRAY_20],
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    lineHeight: '22px',
    padding: '18px',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  text: {
    textAlign: 'center'
  },
  otherForm: {
    display: 'flex',
    flexDirection: 'column',
    height: '300px',
    justifyContent: 'space-around',
    width: '80%'
  },
  labelText: {
    textTransform: 'uppercase'
  },
  list: {
    width: '100%',
    padding: 0,
    margin: 0,
    '& li:last-child': {
      borderBottom: ['1px', 'solid', DARK_GRAY_20]
    }
  },
  icon: {
    stroke: 'var(--emergency-sheet__icon__stroke__color) !important',
    left: '0',
    padding: '0 20px',
    position: 'absolute'
  },
  textContainer: {
    color: 'var(--emergency-sheet__first__child__text__color)',
    fontFamily: 'BentonSansMedium',
    fontSize: '16px',
    lineHeight: '24px'
  }
})
